const CreateSearchHash = (filterObject, newFilter) => {
  let filterOBJ = { ...filterObject };
  delete filterOBJ.cachedPrice;
  delete filterOBJ.Group;
  delete filterOBJ.pageSize;
  delete filterOBJ.sort;
  delete filterOBJ.categories;
  delete filterOBJ.pageIndex;
  filterOBJ = {
    ...filterOBJ,
    ...newFilter,
  };
  if (Object.keys(filterOBJ).length === 0) return null;
  const filterString = JSON.stringify(filterOBJ);
  return btoa(encodeURIComponent(filterString));
};

export const AddIndexInSearchHash = (searchHash, filter) => {
  const FilterObject = JSON.parse(decodeURIComponent(atob(searchHash)));
  const NewFilter = {
    ...FilterObject,
    ...filter,
  };
  const NewFilterString = JSON.stringify(NewFilter);
  return btoa(encodeURIComponent(NewFilterString));
};

export const RemoveIndexInSearchHash = (searchHash, filter) => {
  const FilterObject = JSON.parse(decodeURIComponent(atob(searchHash)));
  const NewFilter = {
    ...FilterObject,
  };

  filter.forEach((e) => {
    if (NewFilter[e]) delete NewFilter[e];
  });

  const NewFilterString = JSON.stringify(NewFilter);
  return btoa(encodeURIComponent(NewFilterString));
};

export default CreateSearchHash;
